import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPrinter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPrinter"><Path fillRule="evenodd" clipRule="evenodd" d="M18 2H6V6H2V18H6V22H18V18H22V6H18V2ZM16 6V4H8V6H16ZM16 15H8V20H16V15ZM6.5 10H10.5V12H6.5V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPrinter;
